import { Injectable } from '@angular/core';
import { CourseModel, CourseRequest } from '@generativ/much-smarter-models';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { Observable } from 'rxjs';
import { ErrorHandlerService } from '../../core/services/error-handler.service';
import {catchError} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class CourseService {

  private coursesURL = environment.msApiUrl + 'courses/';

  constructor(private http: HttpClient,
              private errorHandlerService: ErrorHandlerService) {
  }

  getCourse(id: number): Observable<CourseModel> {
    return this.http.get<CourseModel>(this.coursesURL + id).pipe(
      catchError(this.errorHandlerService.handleError)
    );
  }

  getCourses(): Observable<CourseModel[]> {
    return this.http.get<CourseModel[]>(this.coursesURL).pipe(
      catchError(this.errorHandlerService.handleError)
    );
  }

  createCourse(course: CourseRequest.Create): Observable<CourseModel> {
    return this.http.post<CourseModel>(this.coursesURL, course).pipe(
      catchError(this.errorHandlerService.handleError)
    );
  }

  updateCourse(id: number, course: CourseRequest.Update): Observable<CourseModel> {
    return this.http.patch<CourseModel>(this.coursesURL + id, course).pipe(
      catchError(this.errorHandlerService.handleError)
    );
  }

  toggleActive(id: number): Observable<CourseModel> {
    return this.http.get<CourseModel>(this.coursesURL + id + '/toggleActive').pipe(
      catchError(this.errorHandlerService.handleError)
    );
  }
}
